import * as classRoomApi from '../../services/api/classroomApi';
import { REDUCER } from '../../reducers/reducersConst';
import dayjs from 'dayjs';

export let setBasicAnalyticsData = (basicAnalyticsData = []) => {
  return {
    type: REDUCER.BASIC_ANALYTICS.SET_BASIC_ANALYTICS_DATA,
    basicAnalyticsData
  };
};

export let setBasicAnalyticsDate = (basicAnalyticsDate = { year: dayjs().year(), month: dayjs().month() }) => {
  return {
    type: REDUCER.BASIC_ANALYTICS.SET_BASIC_ANALYTICS_DATE,
    basicAnalyticsDate
  };
};

export let setSelectedStudents = (selectedStudentIds = []) => {
  return {
    type: REDUCER.BASIC_ANALYTICS.SET_SELECTED_STUDENTS,
    selectedStudentIds
  };
};

export let manageBasicAnalyticsDate = (sectionId, basicAnalyticsDate, studentIds = null) => {
  return dispatch => {
    if (sectionId && basicAnalyticsDate) {
      classRoomApi.getBasicAnalytics(sectionId, basicAnalyticsDate, studentIds).then(res => {
        dispatch(setBasicAnalyticsData(res.data));
      });
    }
    dispatch(setBasicAnalyticsDate(basicAnalyticsDate));
  };
};

export let fetchBasicAnalyticsData = (sectionId, basicAnalyticsDate, studentIds = null) => {
  return dispatch => {
    if (sectionId && basicAnalyticsDate) {
      classRoomApi.getBasicAnalytics(sectionId, basicAnalyticsDate, studentIds).then(res => {
        dispatch(setBasicAnalyticsData(res.data));
      });
    }
  };
};
